export const accessManagementRoot = '/access-management'

export const accessManagementRoute = {
  userManagement: '/user-management',
  roles: '/roles',
}
